
export enum ProSummaryTypeCd {
	CUSTOMER = 'Customer',
	SIC = 'Sic',
	WEB = 'Web'}

